var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('li',{staticClass:"come"},[_c('a',{attrs:{"href":"#"}},[_vm._v("关于我们")]),_c('a',[_vm._v("  |  ")]),_c('a',{attrs:{"href":"#"}},[_vm._v(" 网站声明")])]),_c('li',{staticClass:"come"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("蜀ICP备2024090928号-2")])])])
}]

export { render, staticRenderFns }